export default __webpack_public_path__ + "static/media/visa.3e294d8a.svg";